export default __webpack_public_path__ + "static/media/tampo_liso.f3d7e2f6.png";